import { Event } from '@wix/ambassador-events-v1-event/types';

export function getScheduleTbdMessage(event: Event) {
  if (event.scheduling?.config?.scheduleTbd) {
    return event.scheduling.config.scheduleTbdMessage || 'TBD';
  }
}
